<template>
    <b-row class="collection">
        <b-col cols="12" lg="12">
            <b-row>
                <b-col  class="mx-auto text-center col-sm-10 col-md-8">
                    <p class="collection-titulo" style="font-size: 30px;" v-html="content.titulo"></p>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col cols="12" class="mx-auto text-center">
                 <p class="collection-subtitulo" v-html="content.content"></p>
                </b-col>
            </b-row>
            
        </b-col>
        <b-row class="mt-5 col-12 mx-auto mb-5" >
        <b-col cols="12" lg="7" class="pb-6 collection-content">
           
            <b-row class="pt-4 collection-group-parrafo">
                <b-col cols="12">
                   
                    <b-row  class="collection-content-fondo collection-position-fondo">
                    </b-row>
                    <b-row class="collection-content-fondo2">
                        <img src="@/assets/images/user_internal/content_all3.png" alt="">
                    </b-row>
                    
                </b-col>
            </b-row>
        </b-col>
        <b-col class="caja-collection" cols="12 text-center mt-5" lg="5" style="">
            <img class="" src="@/assets/images/user_internal/caja.svg" alt="Box img">
        </b-col>
        <b-col cols="12" lg="12" class="mt-3 pb-3 function-spase">
        </b-col>
        </b-row>
    </b-row>
</template>
<script>

    export default {
        name: 'section-solutions',
        components: {},
        props: {
            content: Object
        },
        data: () => ({
            list: [
                {
                    title: 'Productos',
                    content: 'Canjear productos a <br>precios especiales <br>utilizando tus puntos.'
                },
                {
                    title: 'Promociones',
                    content: 'Genera tus cupones de <br>las promociones<br> exclusivas y disfrutalas<br> en los establecimientos<br> afiliados a <strong>GOX</strong>.'
                },
                {
                    title: 'Descuentos',
                    content: 'Disfruta de los <br>descuentos exclusivos <br>identificandote como <br>cliente <strong>GOX</strong> en nuestros<br> establecimientos<br> afiliados.'
                },
                {
                    title: 'Colecciones exclusivas',
                    content: 'Accede a canjear <br>artículos de nuestras <br>colecciones exclusivas <br>comprando en los<br> establecimientos<br> Indicados.'
                },
            ]
        }),
    }
</script>
<style scoped>

.collection-content-fondo2{
        display: none;
    }

@media (max-width: 600px) {
    .collection {
        padding-top: 30px !important;
        position: relative;
        z-index: 1;
    }

    .collection-content-fondo{
        display: none;
    }

    .collection-content-fondo2{
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .caja-collection {
        display: none;
    }

    .collection-titulo{
        text-align: left;
    }

    .collection-subtitulo {
        text-align: left;
    }
}

</style>